<div.login>
    <div.tabs>
        <ebay-tabs>
            <@tab>登录</@tab>
            <@tab>注册新用户</@tab>
            <@tab>找回/修改 密码</@tab>
            <@panel>
                <div.tab>
                    <div.tab-form>
                        <div.tab-field-username>
                            <ebay-textbox id="tab-username-login"
                                key="tab-username-login"
                                value=state.username
                                floating-label='用户名'
                                on-floating-label-init('emit', 'floating-label-init')
                                on-change("changeUserName")
                            />
                        </div>
                        <!-- <div.login-field-code>
                            <ebay-textbox id="login-code"
                                key="login-code"
                                floating-label='验证码'
                                on-floating-label-init('emit', 'floating-label-init')
                            />
                            <ebay-button id="login-code-btn" href="" on-click("handleSendCodeEvent") >
                                获取验证码
                            </ebay-button>
                        </div> -->
                        <div.tab-field-passwd>
                            <ebay-textbox id="tab-passwd-login"
                                key="tab-passwd-login"
                                type="password"
                                value=state.passwd
                                floating-label='密码'
                                on-floating-label-init('emit', 'floating-label-init')
                                on-change("changePasswd")
                            />
                        </div>
                        <!-- <div.login-field-cb>
                            <ebay-checkbox
                                class="field__control"
                                id="checkbox"
                                on-change("emit", "change")
                                on-focus("emit", "focus")
                                on-keydown("emit", "keydown") />
                            <label class="field__label field__label--end" for="checkbox">
                                我已阅读并同意    服务协议和    隐私声明
                            </label>
                        </div> -->
                        <div.tab-field>
                            <ebay-button id="tab-submit" href="" fluid=true on-click("handleLoginEvent")>
                                提交
                            </ebay-button>
                        </div>
                    </div>
                </div>        
            </@panel>
            <@panel>
                <div.tab>
                    <div.tab-form>
                        <div.tab-field-username>
                            <ebay-textbox id="tab-username-reg"
                                key="tab-username-reg"
                                value=state.username
                                floating-label='用户名'
                                invalid=state.isUserNameInvalid
                                on-floating-label-init('emit', 'floating-label-init')
                                on-change("changeUserName")
                            />
                        </div>
                        <div.tab-field-passwd>
                            <ebay-textbox id="tab-passwd-reg"
                                key="tab-passwd-reg"
                                type="password"
                                value=state.passwd
                                floating-label='新密码'
                                invalid=state.isPasswdInvalid
                                on-floating-label-init('emit', 'floating-label-init')
                                on-change("changePasswd")
                            />
                        </div>
                        <div.tab-field-hint>
                            <ebay-textbox id="tab-hint-reg"
                                key="tab-hint-reg"
                                type="password"
                                value=state.hint
                                floating-label='新密语(用于找回密码)'
                                on-floating-label-init('emit', 'floating-label-init')
                                on-change("changeHint")
                            />
                        </div>                    
                        <div.tab-field>
                            <ebay-button id="tab-submit" href="" fluid=true on-click("handleRegEvent")>
                                提交
                            </ebay-button>
                        </div>
                    </div>
                </div>        
            </@panel>
            <@panel>
                <div.tab>
                    <div.tab-form>
                        <div.tab-field-username>
                            <ebay-textbox id="tab-username-findPasswd"
                                key="tab-username-findPasswd"
                                value=state.username
                                floating-label='用户名'
                                on-floating-label-init('emit', 'floating-label-init')
                                on-change("changeUserName")
                            />
                        </div>
                        <div.tab-field-hint>
                            <ebay-textbox id="tab-hint-findPasswd"
                                key="tab-hint-findPasswd"
                                type="password"
                                value=state.hint
                                floating-label='旧密语'
                                on-floating-label-init('emit', 'floating-label-init')
                                on-change("changeHint")
                            />
                        </div>                    
                        <div.tab-field-passwd>
                            <ebay-textbox id="tab-passwd-findPasswd"
                                key="tab-passwd-findPasswd"
                                type="password"
                                value=state.passwd
                                floating-label='新密码'
                                invalid=state.isPasswdInvalid
                                on-floating-label-init('emit', 'floating-label-init')
                                on-change("changePasswd")
                            />
                        </div>
                        <div.tab-field>
                            <ebay-button id="tab-submit" href="" fluid=true on-click("handleFindPasswdEvent")>
                                提交
                            </ebay-button>
                        </div>
                    </div>
                </div>           
            </@panel>
        </ebay-tabs>
    </div>
    <div.msg id="msg">
        ${state.msg}
    </div>
</div>

